<template>
    <div id="nav" :class="this.type">
        <div class="menu">
            <router-link to="/"><span>Home</span></router-link>
            <router-link to="/story"><span>스토리</span></router-link>
            <router-link to="/shadowSide"><span>새도우 사이드</span></router-link>
            <router-link to="/shineSide"><span>사인 사이드</span></router-link>
            <router-link to="/class"><span>클래스</span></router-link>
            <router-link to="/tower"><span>오만의 탑 / 바이움</span></router-link>
            <router-link to="/ranking"><span>랭킹</span></router-link>
            <router-link to="/skill"><span>정령탄</span></router-link>
        </div>
        <!--<a href="/events/2019//190220_kamael/choice" class="btn_event">EVENT</a>-->
    </div>    
</template>

<script>
import {mapState} from "vuex";

export default {
    computed: {
        ...mapState([
            "currentPage"
        ]),
        type(){
            let className;
            if(this.currentPage == "home"){
                className = "left";
            }else{
                className = 'top'
            }
            return className;
        }
    }    
}
</script>

<style lang="scss">
    #nav {
        /*display:none;*/
        @include position-abs($width:148px, $height:324px, $right:40px, $top:50%); z-index:10;
        .menu{
            &:hover{
                >a>span{
                    opacity:1;
                    transition:0.3s;
                }
            }
            &>a {
                @include hide-text;
                position:relative;
                display: block;
                float:left;
                width:148px;
                height:35px;

                &:before {
                    @include position-abs($width: 14px, $height: 14px, $right: 0px, $top: 10px);
                    display: block;
                    content: '';
                    @include bg($bg: 'img/nav_ico_off_2.png', $position: 0 0);
                }
                &:after{
                    @include position-abs($width:14px, $height:14px, $right:0px, $top:10px);
                    display: block;
                    content: '';
                    @include bg($bg:'img/nav_ico_on.png', $position:0 0);
                    opacity:0;
                    transform: scale(0.5) rotate(90deg);
                    transition:0.3s;
                }

                &>span{
                    display: block;
                    @include position-abs($width:121px, $height:35px, $left:0px, $top:0);
                    overflow: hidden;
                    opacity:0.3;
                    transition:0.3s;
                    &:before{
                        display: block;
                        @include position-abs($width:145px, $height:35px, $left:0px, $top:0);
                        @include bg($bg:'img/nav_txt.png', $position:0 0);
                        content: '';
                    }
                    &:after{
                        display: block;
                        @include position-abs($width:145px, $height:35px, $left:0px, $top:0);
                        @include bg($bg:'img/nav_txt.png', $position:-121px 0px);
                        content: '';
                        opacity:0;
                        transition:0.3s;
                    }
                }

                &:hover, &.router-link-exact-active{
                    &:after {
                        opacity: 1;
                        transform: scale(1);
                        transition:0.3s;
                    }
                    >span:after{
                        opacity:1;
                        transition:0.3s;
                    }
                    >span{
                        opacity:1;
                        transition:0.3s;
                    }
                }

                &:nth-child(2){
                    &>span:before, &>span:after{background-position-y: -35px};
                }
                &:nth-child(3){
                    &>span:before, &>span:after{background-position-y: -70px};
                }
                &:nth-child(4){
                    &>span:before, &>span:after{background-position-y: -105px};
                }
                &:nth-child(5){
                    &>span:before, &>span:after{background-position-y: -140px};
                }
                &:nth-child(6){
                    &>span:before, &>span:after{background-position-y: -175px};
                }
                &:nth-child(7){
                    &>span:before, &>span:after{background-position-y: -210px};
                }
                &:nth-child(8){
                    &>span:before, &>span:after{background-position-y: -245px};
                }
            }
        }
        .btn_event{
            @include hide-text();
            @include position-abs($width:81px, $height:29px, $right:5px, $bottom:0);
            @include bg($bg:'img/btn_1.png', $position:0 0);
        }
    }

    @keyframes navi-animation {
        from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
    @keyframes navi-animation1 {
        from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
</style>


